export default __webpack_public_path__ + "static/media/internetmundial.e1e10452.png";